import React from "react";
import "./homepagecontent.css";
import { FaUpload, FaFolderPlus, FaCloudUploadAlt, FaShareAlt, FaStar } from "react-icons/fa";
import { FaQrcode } from "react-icons/fa6";

const HomePageContent = () => {
  return (
    <div className="home-container">

      {/* WELCOME SECTION */}
      <section className="welcome-sec">
        <div className="welcome-header">

          {/* DATE */}
          <p className="today-date">
            {new Date().toLocaleDateString("en-US", {
              weekday: "long",
              month: "long",
              day: "numeric",
              year: "numeric"
            })}
          </p>

          {/* WELCOME */}
          <h2>Welcome Back 👋 Deepak</h2>
          <p>Your cloud dashboard is ready to explore.</p>

        </div>

        <div className="svg-animation">
          <img src="/education-animate.svg" alt="Education Animation" />
        </div>
      </section>
     {/* QUICK ACTION CARDS */}
<section className="quick-action-cards">

  <div className="action-card">
    <FaUpload className="action-icon" />
    <p>Upload File</p>
  </div>

  <div className="action-card">
    <FaFolderPlus className="action-icon" />
    <p>Create Folder</p>
  </div>

  <div className="action-card">
    <FaCloudUploadAlt className="action-icon" />
    <p>Upload Folder</p>
  </div>

  <div className="action-card">
    <FaShareAlt className="action-icon" />
    <p>Share</p>
  </div>

  <div className="action-card">
    <FaQrcode className="action-icon" />
    <p>QR Code</p>
  </div>

</section>

      {/* RECENT FILES */}
   <section className="recent-files">
  <h5>Recent Files</h5>

  <div className="files-grid">

    <div className="file-item">
      <span>📄 Unit1.pdf</span>
      <small>Today</small>
    </div>

    <div className="file-item">
      <span>📄 ImportantQns.pdf</span>
      <small>Yesterday</small>
    </div>

    <div className="file-item">
      <span>📄 Notes.docx</span>
      <small>2 days ago</small>
    </div>

    <div className="file-item">
      <span>📄 Syllabus.pdf</span>
      <small>Last Week</small>
    </div>

  </div>
</section>

      {/* QUICK FOLDERS */}
      <section className="quick-folders">

  <div className="folder-storage-row">

    {/* LEFT SIDE — Folders */}
    <div className="folders-sec">
      <h5>Your Folders</h5>
      <div className="folder-grid">
        <div className="folder-card"><h1>📁</h1> <p> Notes</p></div>
        <div className="folder-card"><h1>📁</h1> <p>Textbooks</p></div>
        <div className="folder-card"><h1>📁</h1> <p>Model Papers</p> </div>
        <div className="folder-card"><h1>📁</h1> <p>Assignments</p></div>
        <div className="folder-card"><h1>📁</h1> <p>Projects</p></div>
        <div className="folder-card"><h1>📁</h1> <p>Question Banks</p></div>
      </div>
    </div>   

  </div>

</section>


      {/* STORAGE SUMMARY */}
      <section className="storage-card">
       
      </section>

    </div>
  );
};

export default HomePageContent;
